import { WbsFrontend } from '@interserve/igx-angular'

export const dashboardCatalogHubInfo: WbsFrontend = {
    layout: {
        header: {
            label: '商品カタログを選択',
        },
        footer: {
            buttons: [
                {
                    key: 'select',
                    label: '選択',
                    color: 'primary',
                    action: 'select',
                },
                {
                    key: 'cancel',
                    label: 'キャンセル',
                    color: 'cancel',
                    action: 'close',
                },
            ],
        },
        leftWbs: {
            type: 'grid',
        },
        leftWbsRules: {
            childDataKey: 'nodeObjects',
            hideHeader: false,
            height: '300px',
            width: '100%',
            rowSelection: 'single',
            noSelectionWbsTypes: ['catalog'],
            fields: [
                {
                    name: 'name',
                    label: '名称',
                    width: '100%',
                    dataType: 'string',
                },
            ],
            actionRules: {
                init: [
                    {
                        apiUrl: '//backend-wbsprotoapi.backend.out.nakamenosakura.com/api/indexWbs/fqdn?fqdn=catalog.prototype.nameCardList.narrowing.services',
                        apiMethod: 'get',
                    },
                ],
            },
        },
    },
}

//★★フロントエンド設定の内容が固まったら、IndexCoreに入れて、APIで呼び出しする
export const appInitialize = {
    indexAppCd: 'documentWbs',
    frontendCd: 'appInitialize',
    items: {
        layout: {
            header: {
                label: '',
                title: 'Biz-Marche',
                titleLink: 'https://prototype-dashboard-ui.backend.out.nakamenosakura.com',
                subTitle: '文書管理',
                subTitleLink: 'top',
                subTitleColor: '#c27a16',
            },
            menu: [
                {
                    path: 'top',
                    title: 'Top',
                },
                {
                    path: 'select-area',
                    title: 'ドキュメント管理',
                },
                {
                    path: 'settings',
                    title: '設定',
                    children: [
                        {
                            path: 'settings/create-area',
                            title: 'エリア作成',
                        },
                        {
                            path: 'settings/select-area-for-areauser',
                            title: 'エリアユーザー管理',
                        },
                    ],
                },
            ],
        },
    },
}
